import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CeroInput from "../../../../components/CeroInput";
import { getCountryList, getStates } from "../../../../redux/actions";
import CeroAutoComplete from "../../../../components/CeroAutoComplete";
import CeroPhoneInput from "../../../../components/CeroPhoneInput";
import CeroDate from "../../../../components/CeroDate";
import TotalEmployeesTable from "../BrsrTables/TotalEmployeesTable";
import TotalEmployeesTable2 from "../BrsrTables/TotalEmployeesTable2";
import GrievanceMechanismTable from "../BrsrTables/GrievanceMechanismTable";
import ShareholdingTable from "../BrsrTables/ShareholdingTable";
import MaterialIssuesTable from "../BrsrTables/MaterialIssuesTable";
import DisclosureTable from "../BrsrTables/DisclosureTable";
import BoardReviewTable from "../BrsrTables/BoardReviewTable";
import ReviewFrequencyTable from "../BrsrTables/ReviewFrequencyTable";
import PolicyGapReasonTable from "../BrsrTables/PolicyGapReasonTable";
import TrainingAwarenessTable from "../BrsrTables/TrainingAwarenessTable";
import LegalActionsTable from "../BrsrTables/LegalActionsTable";
import CaseStudiesTable from "../BrsrTables/CaseStudiesTable";
import ConflictOfInterestTable from "../BrsrTables/ConflictOfInterestTable";
import AccountsPayableTable from "../BrsrTables/AccountsPayableTable";
import ConcentrationMetricsTable from "../BrsrTables/ConcentrationMetricsTable";
import AwarenessProgramTable from "../BrsrTables/AwarenessProgramTable";
import ImprovementImpactTable from "../BrsrTables/ImprovementImpactTable";
import ImprovementImpactTable1 from "../BrsrTables/ImprovementImpactTable1";
import ProductRiskTable from "../BrsrTables/ProductRiskTable";
import RecycledMaterialTable from "../BrsrTables/RecycledMaterialTable";
import WasteManagementTable from "../BrsrTables/WasteManagementTable";
import ReclaimedPackagingTable from "../BrsrTables/ReclaimedPackagingTable";
import EmployeeBenefitCoverageTable from "../BrsrTables/EmployeeBenefitCoverageTable";
import EmployeeCountComparisonTable from "../BrsrTables/EmployeeCountComparisonTable";
import WorkersBenefitCoverageTable from "../BrsrTables/WorkerBenefitCoverageTable";
import WellBeingCostTable from "../BrsrTables/WellBeingCostTable";
import StatutoryBenefitsTable from "../BrsrTables/StatutoryBenefitsTable";
import ReturnToWorkRateTable from "../BrsrTables/ReturnToWorkRateTable";
import ReclaimedProductTable from "../BrsrTables/ReclaimedProductTable";
import UnionAssociationTable from "../BrsrTables/UnionAssociationTable";
import TrainingMeasuresTable from "../BrsrTables/TrainingMeasuresTable";
import WorkforceFYTable from "../BrsrTables/WorkforceFYTable";
import SafetyIncidentTable from "../BrsrTables/SafetyIncidentTable";
import PfGratuityDisputeTable from "../BrsrTables/PfGratuityDisputeTable";
import AssessmentTable from "../BrsrTables/AssessmentTable";
import RehabilitationEmploymentTable from "../BrsrTables/RehabilitationEmploymentTable";
import ValueChainAssessmentTable from "../BrsrTables/ValueChainAssessmentTable";
import StakeholderEngagementTable from "../BrsrTables/StakeholderEngagementTable";
import CoverageComparisonTable from "../BrsrTables/CoverageComparisonTable";
import WageDistributionTable from "../BrsrTables/WageDistributionTable";
import RemunerationTable from "../BrsrTables/RemunerationTable";
import FemaleWagePercentageTable from "../BrsrTables/FemaleWagePercentageTable";
import HumanRightsComplaintsTable from "../BrsrTables/HumanRightsComplaintTable";
import PoshComplaintsTable from "../BrsrTables/PoshComplaintsTable";
import PlantAssessmentTable from "../BrsrTables/PlantAssessmentTable";
import PartnerEthicsAssessmentTable from "../BrsrTables/PartnerEthicsAssessmentTable";
import EnergyConsumptionTable from "../BrsrTables/EnergyConsumptionTable";
import WaterWithdrawalAndConsumptionTable from "../BrsrTables/WaterWithdrawalAndConsumptionTable";
import WaterDischargeTreatmentTable from "../BrsrTables/WaterDischargeTreatmentTable";
import AirPollutantEmissionTable from "../BrsrTables/AirPollutantEmissionTable";
import Scope1And2GHGEmissionTable from "../BrsrTables/Scope1And2GHGEmissionTable.jsx";
import WasteManagementEntityTable from "../BrsrTables/WasteManagementEntityTable.jsx";
import EnvironmentalClearanceTable from "../BrsrTables/EnvironmentalClearanceTable";
import EIAComplianceTable from "../BrsrTables/EIAComplianceTable";
import RegulatoryNonComplianceTable from "../BrsrTables/RegulatoryNonComplianceTable";
import WaterUsageAndDischargeTable from "../BrsrTables/WaterUsageAndDischargeTable";
import Scope3EmissionsTable from "../BrsrTables/Scope3EmissionsTable";
import InitiativeOutcomeTable from "../BrsrTables/InitiativeOutcomeTable";
import TradeAssociationsTable from "../BrsrTables/TradeAssociationsTable";
import LegalAuthoritiesTable from "../BrsrTables/LegalAuthoritiesTable";
import PublicPolicyAdvocacyTable from "../BrsrTables/PublicPolicyAdvocacyTable";
import SIATable from "../BrsrTables/SIATable";
import RehabilitationResettlementTable from "../BrsrTables/RehabilitationResettlementTable";
import SourcingBreakdownTable from "../BrsrTables/SourcingBreakdownTable";
import LocationDistributionTable from "../BrsrTables/LocationDistributionTable";
import SocialImpactActionTable from "../BrsrTables/SocialImpactActionTable";
import AspirationalDistrictTable from "../BrsrTables/AspirationalDistrictTable";
import TraditionalKnowledgeTable from "../BrsrTables/TraditionalKnowledgeTable";
import RegulatoryCaseTable from "../BrsrTables/RegulatoryCaseTable";
import CSRBeneficiariesTable from "../BrsrTables/CSRBeneficiariesTable";
import TurnoverParameterTable from "../BrsrTables/TurnoverParameterTable";
import CustomerComplaintsTable from "../BrsrTables/CustomerComplaintsTable";
import ProductRecallTable from "../BrsrTables/ProductRecallTable";
import CeroChipSelect from "../../../../components/CeroChipSelect";

function BrsrQuestionnaire({
  handleCheckboxChange,
  handleSingleSelect,
  handleTextInputChange,
  textAnswers,
  selectedValues,
  employeeTable,
  setEmployeeTable,
  employeeTable2,
  setEmployeeTable2,
  grievanceTable,
  setGrievanceTable,
  shareholdingTable,
  setShareholdingTable,
  materialTable,
  setMaterialTable,
  disclosureData,
  setDisclosureData,
  reviewData,
  setReviewData,
  frequencyData,
  setFrequencyData,
  reasonData,
  setReasonData,
  trainingData,
  setTrainingData,
  legalData,
  setLegalData,
  caseStudies,
  setCaseStudies,
  data,
  setData,
  conflictData,
  setConflictData,
  payableData,
  setPayableData,
  concentrationtableData,
  setConcentrationTableData,
  awarenessData,
  setAwarenessData,
  improvementData,
  setImprovementData,
  improvementData1,
  setImprovementData1,
  productrows,
  setProductRows,
  recycledData,
  setRecycledData,
  wastedata,
  setWasteData,
  packagedata,
  setPackageData,
  benifitTable,
  setBenifitTable,
  workersbenefitTable,
  setWorkersBenefitTable,
  wellbeingdata,
  setWellbeingData,
  statutorydata,
  setStatutoryData,
  returndata,
  setReturnData,
  reclaimedproductdata,
  setReclaimedProductData,
  uniondata,
  setUnionData,
  trainingmeasuresdata,
  setTrainingMeasuresData,
  fydata,
  setFyData,
  safetyData,
  setSafetyData,
  pfdata,
  setPfData,
  assessmentData,
  setAssessmentData,
  rehabdata,
  setRehabData,
  valuedata,
  setValueData,
  stakeholderdata,
  setStakeholderData,
  coveragedata,
  setCoverageData,
  wageData,
  setWageData,
  remunerationdata,
  setRemunerationData,
  femaleWageData,
  setFemaleWageData,
  humanrightsdata,
  setHumanrightsData,
  poshData,
  setPoshData,
  plantAssessmentData,
  setPlantAssessmentData,
  valueChainAssessmentData,
  setValueChainAssessmentData,
  energyData,
  setEnergyData,
  waterData,
  setWaterData,
  dischargeData,
  setDischargeData,
  airdata,
  setAirData,
  scopeData,
  setScopeData,
  wasteManagementData,
  setWasteManagementData,
  envclearanceData,
  setEnvClearanceData,
  eiaData,
  setEiaData,
  nonComplianceData,
  setNonComplianceData,
  waterusagedata,
  setWaterUsageData,
  scope3Data,
  setScope3Data,
  initiativeData,
  setInitiativeData,
  associations,
  setAssociations,
  authorityData,
  setAuthorityData,
  advocacyData,
  setAdvocacyData,
  siaData,
  setSiaData,
  resettlementData,
  setResettlementData,
  sourcingData,
  setSourcingData,
  locationData,
  setLocationData,
  socialImpactData,
  setSocialImpactData,
  aspirationalDistrictData,
  setAspirationalDistrictData,
  traditionalKnowledgeData,
  setTraditionalKnowledgeData,
  regulatoryCaseData,
  setRegulatoryCaseData,
  csrBeneficiaryData,
  setCsrBeneficiaryData,
  turnoverData,
  setTurnoverData,
  complaintData,
  setComplaintData,
  recallData,
  setRecallData,

  handleDateInputChange,
  dateAnswers,
}) {
  const classes = useStyles();
  const materialityQuestions = useSelector((state) => {
    const data = state.emission.getStandardsQuestionnaire.data.questions_list;
    return Array.isArray(data) ? data : [];
  });

  const specificQuestionId = "Date of publication";

  const toggleValueInList = (list, value) => {
    const index = list.indexOf(value);
    if (index === -1) {
      // Value not found, add it
      list.push(value);
    } else {
      // Value found, remove it
      list.splice(index, 1);
    }
    return list;
  };

  useEffect(() => {
    const existingAnswer = textAnswers[specificQuestionId];
    if (!existingAnswer || existingAnswer === "") {
      const today = new Date().toLocaleDateString("en-GB");
      handleTextInputChange(specificQuestionId, today);
    }
  }, [specificQuestionId]);

  const questionDict = {};
  const subQuestionDict = {};

  const dispatch = useDispatch();
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  /////country/////////
  const countryListData = useSelector(
    (state) => state.listings.countryList.data
  );
  const countryList =
    countryListData?.map((item) => ({
      id: item.code,
      label: item.name,
    })) || [];

  const stateList = useSelector((state) => state.listings.getStates.data);

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  const stateNames = stateList.reduce((acc, state) => {
    const [key, value] = Object.entries(state)[0];
    acc[value] = value;
    return acc;
  }, {});

  const countryNames = countryList.reduce((acc, s) => {
    acc[s.label] = s.id;
    return acc;
  }, {});
  useEffect(() => {
    dispatch(getCountryList());
  }, [dispatch]);

  useEffect(() => {
    if (country && country.id) {
      dispatch(getStates(country.id));
    }
  }, [country]);
  useEffect(() => {
    const countryQuestion = materialityQuestions.find(
      (q) => q.question.toLowerCase() === "select country"
    );

    if (textAnswers[countryQuestion?.id])
      dispatch(getStates(textAnswers[countryQuestion?.id]));
  }, [textAnswers]);

  const [marketCountry, setMarketCountry] = useState([]);
  const [marketState, setMarketState] = useState([]);

  const marketsServedQuestion = materialityQuestions.find(
    (q) => q.question === "Markets served:"
  );

  useEffect(() => {
    const nationalChildId = subQuestionDict[marketsServedQuestion?.id]?.find(
      (q) => q.question === "National:"
    )?.id;

    const internationalChildId = subQuestionDict[
      marketsServedQuestion?.id
    ]?.find((q) => q.question === "International:")?.id;

    // Prepopulate International (country)
    if (marketCountry.length === 0 && textAnswers[internationalChildId]) {
      setMarketCountry(textAnswers[internationalChildId]);
    }

    // Prepopulate National (state)
    if (marketState.length === 0 && textAnswers[nationalChildId]) {
      setMarketState(textAnswers[nationalChildId]);
    }
  }, [marketCountry, marketState, textAnswers, countryList, stateNames]);

  function toRoman(num) {
    const romanMap = {
      1: "I",
      2: "II",
      3: "III",
      4: "IV",
      5: "V",
      6: "VI",
      7: "VII",
      8: "VIII",
      9: "IX",
      10: "X",
      11: "XI",
      12: "XII",
      13: "XIII",
      14: "XIV",
      15: "XV",
    };
    return romanMap[num] || "Invalid";
  }

  const SectionDescription = ({ subSection }) => {
    if (
      subSection.trim().toUpperCase() ===
      "BUSINESS RESPONSIBILITY & SUSTAINABILITY REPORTING QUESTIONNAIRE"
    ) {
      return (
        <Typography
          variant="body1"
          fontSize={16}
          fontWeight={500}
          paddingTop="8px"
          paddingBottom="16px"
          paddingLeft="4px"
          sx={{ color: "black", width: "100%" }}
        >
          This section is aimed at helping businesses demonstrate the
          structures, policies and processes put in place towards adopting the
          NGRBC Principles and Core Elements.
        </Typography>
      );
    }
    return null;
  };

  materialityQuestions.forEach((q) => {
    const { main_section, section, sub_section, question_id } = q;

    if (!questionDict[main_section]) questionDict[main_section] = {};
    if (!questionDict[main_section][section])
      questionDict[main_section][section] = {};
    if (!questionDict[main_section][section][sub_section])
      questionDict[main_section][section][sub_section] = [];

    if (question_id !== "None") {
      if (!subQuestionDict[question_id]) subQuestionDict[question_id] = [];
      subQuestionDict[question_id].push(q);
    }

    questionDict[main_section][section][sub_section].push(q);
  });

  return (
    <div>
      {materialityQuestions.length > 0 && (
        <Grid mb={20}>
          <div className={classes.questionList}>
            {Object.keys(questionDict).map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                {/* <div className={classes.scoreDiv}> */}
                {/* <Typography
                    fontSize={20}
                    fontWeight={550}
                    variant="h3"
                    paddingTop="5px"
                    paddingBottom="5px"
                  >
                    {section.toUpperCase()}
                  </Typography> */}

                {/* <SectionDescription section={section} /> */}
                {/* </div> */}

                {Object.keys(questionDict[section]).map(
                  (subSection, subIndex) => {
                    let displayCounter = 1;

                    return (
                      <div key={subIndex}>
                        {subSection.trim().toLowerCase() ===
                          "policy and management processes" && (
                          <Typography
                            fontSize={16}
                            fontWeight={400}
                            paddingTop="8px"
                            paddingBottom="16px"
                            paddingLeft="4px"
                            sx={{ color: "#555", maxWidth: "900px" }}
                          >
                            This section captures the key management policies,
                            frameworks, and procedures in place to support
                            responsible business practices aligned with NGRBC
                            Principles.
                          </Typography>
                        )}
                        <Typography
                          fontSize={19}
                          fontWeight={600}
                          variant="h4"
                          paddingTop="10px"
                        >
                          {subSection}
                        </Typography>
                        {subSection?.toUpperCase().includes("SECTION B:") && (
                          <SectionDescription subSection={section} />
                        )}

                        {/* <Typography>section display</Typography>; */}
                        {(() => {
                          const displayedPrinciples = new Set();

                          return Object.entries(
                            questionDict[section][subSection]
                          ).map(([subSubSectionName, questions], idx) => {
                            const isPrincipleHeading = subSubSectionName
                              ?.toLowerCase()
                              ?.includes("principle");

                            const shouldShowHeading =
                              !isPrincipleHeading ||
                              !displayedPrinciples.has(subSubSectionName);

                            if (isPrincipleHeading) {
                              displayedPrinciples.add(subSubSectionName);
                            }

                            return (
                              <div
                                key={idx}
                                className={
                                  (subSection ===
                                    "SECTION A: GENERAL DISCLOSURES" &&
                                    subSubSectionName ===
                                      "Details of the listed entity") ||
                                  subSubSectionName === "CSR Details"
                                    ? classes.sideBySide
                                    : classes.fullSide
                                }
                              >
                                {subSubSectionName &&
                                  shouldShowHeading &&
                                  (() => {
                                    const normalized = subSubSectionName
                                      ?.trim()
                                      ?.toLowerCase();
                                    const isPrincipleHeading =
                                      normalized?.startsWith("principle");

                                    const targetQPrinciple2 =
                                      "percentage of r&d and capital expenditure (capex) investments in specific technologies";
                                    const targetQPrinciple3 =
                                      "details of measures for the well-being of employees and workers";

                                    const containsTarget = (targetText) =>
                                      questions.some((q) =>
                                        q.question
                                          ?.toLowerCase()
                                          .startsWith(targetText)
                                      );

                                    const isPrinciple2 =
                                      normalized.startsWith("principle 2");
                                    const isPrinciple3 =
                                      normalized.startsWith("principle 3");

                                    if (
                                      (isPrinciple2 &&
                                        !containsTarget(targetQPrinciple2)) ||
                                      (isPrinciple3 &&
                                        !containsTarget(targetQPrinciple3))
                                    ) {
                                      return null;
                                    }

                                    return (
                                      <Typography
                                        fontSize={19}
                                        fontWeight={600}
                                        paddingLeft={4}
                                        paddingTop={2}
                                        paddingBottom={2}
                                        width="100%"
                                      >
                                        {isPrincipleHeading
                                          ? subSubSectionName
                                          : `${toRoman(
                                              idx + 1
                                            )}. ${subSubSectionName}`}
                                      </Typography>
                                    );
                                  })()}

                                {questions.map((question, qtnIdx) => {
                                  let displayIndex = null;
                                  const isEmail =
                                    question.question.toLowerCase() ==
                                    "email id:";

                                  const stateOptions = Array.isArray(stateNames)
                                    ? Object.keys(stateNames).map((s) => ({
                                        label: s,
                                        value: s,
                                      }))
                                    : [];

                                  const countryOptions = Array.isArray(
                                    countryList
                                  )
                                    ? countryList.map((c) => ({
                                        label: c.name,
                                        value: c.id,
                                      }))
                                    : [];

                                  const isChildOfMarketsServed =
                                    question.question_id ===
                                      "6835598169f8900d43a5dd46" &&
                                    (question.question === "National:" ||
                                      question.question === "International:");
                                  if (isChildOfMarketsServed) return null;

                                  // ✅ Handle "Markets served:" custom
                                  if (question.question === "Markets served:") {
                                    displayIndex = displayCounter++;

                                    const nationalChild = subQuestionDict[
                                      question.id
                                    ]?.find((c) => c.question === "National:");
                                    const internationalChild = subQuestionDict[
                                      question.id
                                    ]?.find(
                                      (c) => c.question === "International:"
                                    );

                                    return (
                                      <Box
                                        key={question.id}
                                        paddingRight={2}
                                        marginBottom={3}
                                        className={
                                          [
                                            "Details of the listed entity",
                                            "CSR Details",
                                          ].includes(subSection)
                                            ? classes.halfSide
                                            : classes.fullSide
                                        }
                                      >
                                        <Typography
                                          fontSize={18}
                                          fontWeight={500}
                                          variant="h3"
                                          paddingLeft={4}
                                          paddingBottom={2}
                                        >
                                          {displayIndex}. {question.question}
                                        </Typography>

                                        <Grid
                                          container
                                          spacing={2}
                                          paddingLeft={6}
                                        >
                                          {/* NATIONAL – Uses shared stateNames from Corporate Address logic */}
                                          <Grid item xs={6}>
                                            <Typography
                                              fontWeight={600}
                                              paddingBottom={1}
                                            >
                                              National:
                                            </Typography>
                                            <CeroChipSelect
                                              required
                                              id="states"
                                              name="states"
                                              label={"Select States"}
                                              optionsde={stateNames}
                                              selected={marketState}
                                              formControlClass={
                                                classes.MultiSelectformControl
                                              }
                                              handleChange={(e, value) => {
                                                const updatedArray =
                                                  toggleValueInList(
                                                    marketState,
                                                    value.props.value
                                                  );
                                                setMarketState(updatedArray);
                                                handleTextInputChange(
                                                  nationalChild?.id,
                                                  updatedArray || ""
                                                );
                                              }}
                                              classes={{
                                                justCheckSelected:
                                                  classes.justCheckSelected,
                                              }}
                                            />
                                          </Grid>

                                          {/* INTERNATIONAL – Independent Country List */}
                                          <Grid item xs={6}>
                                            <Typography
                                              fontWeight={600}
                                              paddingBottom={1}
                                            >
                                              International:
                                            </Typography>
                                            <CeroChipSelect
                                              required
                                              id="countries"
                                              name="countries"
                                              label={"Select Countries"}
                                              optionsde={countryNames}
                                              selected={marketCountry}
                                              formControlClass={
                                                classes.MultiSelectformControl
                                              }
                                              handleChange={(e, value) => {
                                                const updatedArray =
                                                  toggleValueInList(
                                                    marketCountry,
                                                    value.props.value
                                                  );
                                                setMarketCountry(updatedArray);
                                                handleTextInputChange(
                                                  internationalChild?.id,
                                                  updatedArray || ""
                                                );
                                              }}
                                              classes={{
                                                justCheckSelected:
                                                  classes.justCheckSelected,
                                              }}
                                            />
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    );
                                  }

                                  const isHeadingOnly =
                                    !question.question_type &&
                                    !question.options?.length;
                                  const questionText =
                                    question?.question?.toLowerCase() || "";
                                  const isIfYesByText =
                                    questionText.startsWith("if yes") ||
                                    questionText.startsWith("-> if yes") ||
                                    questionText.startsWith("if yes, provide");

                                  const isIfNoByText =
                                    questionText.startsWith("if no");
                                  const isIfNotWhetherByText =
                                    questionText.startsWith("if not, whether");
                                  const isIfSoByText =
                                    questionText.startsWith("-> if so");

                                  const isLinkedSubQuestion =
                                    question.question_id &&
                                    question.question_id !== "None";

                                  const parentQuestionId = isLinkedSubQuestion
                                    ? question.question_id
                                    : questions[qtnIdx - 1]?.id;

                                  const parentQuestion = questions.find(
                                    (q) => q.id === parentQuestionId
                                  );

                                  const isSubQuestion =
                                    isIfYesByText ||
                                    isIfNoByText ||
                                    isIfNotWhetherByText ||
                                    isIfSoByText ||
                                    (isLinkedSubQuestion && parentQuestion);

                                  let isYesSelected = false;
                                  if (
                                    parentQuestion?.question_type ===
                                    "multiselect_check_box"
                                  ) {
                                    const selected =
                                      selectedValues?.[parentQuestionId];
                                    isYesSelected =
                                      Array.isArray(selected) &&
                                      selected.length > 0;
                                  } else {
                                    isYesSelected =
                                      selectedValues?.[parentQuestionId] ===
                                      "Yes";
                                  }

                                  const isParentHeadingOnly =
                                    parentQuestion?.question_type === "";
                                  const isMaterialTopicsGroup =
                                    question.question_type ===
                                      "multiselect_check_box" &&
                                    [
                                      "Social:",
                                      "Environmental:",
                                      "Economic:",
                                    ].includes(question.question);

                                  const parentSelectedValue =
                                    selectedValues?.[parentQuestionId];
                                  const lowerQ =
                                    question?.question?.toLowerCase() || "";
                                  const shouldShowSubQuestion = (() => {
                                    if (
                                      lowerQ.startsWith("if not") ||
                                      lowerQ.startsWith("if not,") ||
                                      lowerQ.includes("if not")
                                    ) {
                                      return (
                                        typeof parentSelectedValue ===
                                          "string" &&
                                        parentSelectedValue.toLowerCase() ===
                                          "no"
                                      );
                                    }

                                    if (
                                      lowerQ.startsWith("if yes") ||
                                      lowerQ.startsWith("-> if yes") ||
                                      lowerQ.startsWith("if available")
                                    ) {
                                      return (
                                        typeof parentSelectedValue ===
                                          "string" &&
                                        parentSelectedValue.toLowerCase() ===
                                          "yes"
                                      );
                                    }

                                    if (lowerQ.startsWith("if no")) {
                                      return (
                                        typeof parentSelectedValue ===
                                          "string" &&
                                        parentSelectedValue.toLowerCase() ===
                                          "no"
                                      );
                                    }

                                    // For linked sub-questions not starting with "If"
                                    if (
                                      !lowerQ.startsWith("if") &&
                                      isLinkedSubQuestion
                                    ) {
                                      return (
                                        typeof parentSelectedValue ===
                                          "string" &&
                                        parentSelectedValue.toLowerCase() ===
                                          "yes"
                                      );
                                    }

                                    return false;
                                  })();

                                  if (
                                    (isSubQuestion || isLinkedSubQuestion) &&
                                    !shouldShowSubQuestion &&
                                    !isParentHeadingOnly &&
                                    !isMaterialTopicsGroup
                                  ) {
                                    return null;
                                  }

                                  if (!isSubQuestion)
                                    displayIndex = displayCounter++;

                                  return (
                                    <Grid
                                      key={question?.id}
                                      className={
                                        (subSection ===
                                          "SECTION A: GENERAL DISCLOSURES" &&
                                          subSubSectionName ===
                                            "Details of the listed entity" &&
                                          ![
                                            "corporate address",
                                            "name and contact details",
                                            "reporting boundary",
                                          ].some((term) =>
                                            question?.question
                                              ?.toLowerCase()
                                              .includes(term)
                                          )) ||
                                        (subSubSectionName === "CSR Details" &&
                                          ["turnover", "net worth"].some(
                                            (term) =>
                                              question?.question
                                                ?.toLowerCase()
                                                .includes(term)
                                          ))
                                          ? classes.halfSide
                                          : question.question_type === "text" ||
                                            question.question_type ===
                                              "Text Field"
                                          ? classes.inputGrid
                                          : question?.question
                                              ?.toLowerCase()
                                              .includes("corporate address") ||
                                            question?.question
                                              ?.toLowerCase()
                                              .includes(
                                                "csr is applicable as per section"
                                              )
                                          ? classes.gridItemAdd
                                          : classes.gridItem
                                      }
                                    >
                                      {question?.question !== "" && (
                                        <>
                                          {question.question.includes(
                                            "Provide examples of how stakeholder engagement has directly influenced"
                                          ) ? (
                                            <>
                                              <Typography
                                                fontSize={18}
                                                fontWeight={500}
                                                variant="h3"
                                                paddingLeft={4}
                                                paddingBottom={2}
                                              >
                                                {displayIndex}.{" "}
                                                {question?.question
                                                  .split("")
                                                  .map((part, index) =>
                                                    index === 0
                                                      ? part.trim()
                                                      : `(${part}`
                                                  )
                                                  .join(" ")}{" "}
                                              </Typography>
                                              <Typography
                                                fontSize={16}
                                                fontWeight={400}
                                                paddingLeft={6}
                                                paddingBottom={2}
                                                sx={{ whiteSpace: "pre-line" }}
                                              >
                                                i. The design or implementation
                                                of actions to address impacts.
                                                {"\n"}
                                                ii. The evaluation of the
                                                effectiveness of these actions.
                                                (E.g., stakeholders recommending
                                                alternative solutions,
                                                highlighting additional areas of
                                                concern)
                                              </Typography>
                                            </>
                                          ) : question.question
                                              .toLowerCase()
                                              .includes(
                                                "business practices that create risks or opportunities"
                                              ) ? (
                                            <div
                                              style={{
                                                paddingLeft: 4,
                                                paddingBottom: 2,
                                                display: "ruby",
                                              }}
                                            >
                                              {displayIndex !== null &&
                                                `${displayIndex}. `}
                                              {(() => {
                                                const text = question.question;
                                                const parts =
                                                  text.split("issues");
                                                return (
                                                  <>
                                                    <Typography
                                                      fontSize={18}
                                                      fontWeight={500}
                                                      variant="h3"
                                                    >
                                                      {parts[0]}issues
                                                    </Typography>
                                                    <Typography
                                                      fontSize={18}
                                                      fontWeight={500}
                                                      variant="h3"
                                                      textAlign="justify"
                                                      paddingLeft="31px"
                                                    >
                                                      {parts[1] +
                                                        "" +
                                                        parts[2] +
                                                        "" +
                                                        parts[3]}
                                                    </Typography>
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          ) : question.question
                                              .toLowerCase()
                                              .includes(
                                                "settlement amount paid in proceedings"
                                              ) ? (
                                            <Typography
                                              fontSize={18}
                                              fontWeight={500}
                                              variant="h3"
                                              paddingLeft={4}
                                              paddingBottom={2}
                                            >
                                              {displayIndex !== null &&
                                                `${displayIndex}. `}
                                              {
                                                "Details of fines / penalties /punishment/ award/ compounding fees/ settlement amount paid in proceedings(by theentity or by directors / KMPs) with regulators/ law  enforcement agencies/ judicial institutions, in the financial year, in the following format:"
                                              }
                                            </Typography>
                                          ) : (
                                            <Typography
                                              fontSize={18}
                                              fontWeight={500}
                                              variant="h3"
                                              paddingLeft={4}
                                              paddingBottom={2}
                                            >
                                              {displayIndex !== null &&
                                                `${displayIndex}. `}
                                              {question?.question
                                                .split("(")
                                                .map((part, index) =>
                                                  index === 0
                                                    ? part.trim()
                                                    : `(${part}`
                                                )
                                                .join(" ")}{" "}
                                            </Typography>
                                          )}
                                        </>
                                      )}
                                      <Box
                                        display="flex"
                                        paddingLeft={6}
                                        flexWrap="wrap"
                                      >
                                        {(question?.question_type ===
                                          "choose_from_option" ||
                                          question?.question_type ===
                                            "Choose from Options") && (
                                          <div
                                            style={{
                                              display: "grid",

                                              gridTemplateColumns: `repeat(${
                                                question.options.some(
                                                  (option) =>
                                                    option.split(" ").length > 5
                                                )
                                                  ? 2
                                                  : 4
                                              }, 1fr)`,
                                              gap: "16px",
                                              alignItems: "left",
                                              position: "relative",
                                              textAlign: "left",
                                            }}
                                          >
                                            {question?.options?.map(
                                              (option, idx) => (
                                                <React.Fragment key={idx}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        className={
                                                          classes.selectCheckbox
                                                        }
                                                        checked={
                                                          selectedValues &&
                                                          selectedValues[
                                                            question?.id
                                                          ] === option
                                                        }
                                                        onChange={() =>
                                                          handleSingleSelect(
                                                            question.id,
                                                            option
                                                          )
                                                        }
                                                        value={option}
                                                        sx={{
                                                          color:
                                                            "#5A404E !important",
                                                          borderWidth: "none",
                                                          "&.Mui-checked": {
                                                            color:
                                                              "#8C2148 !important",
                                                          },
                                                        }}
                                                      />
                                                    }
                                                    label={option}
                                                  />
                                                  {selectedValues[
                                                    question.id
                                                  ] &&
                                                    /other/i.test(
                                                      selectedValues[
                                                        question.id
                                                      ]
                                                    ) &&
                                                    /other/i.test(option) && (
                                                      <TextField
                                                        variant="outlined"
                                                        placeholder="Please type your Answer"
                                                        multiline
                                                        rows={3}
                                                        value={
                                                          textAnswers[
                                                            `other-${question.id}`
                                                          ] || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleTextInputChange(
                                                            `other-${question.id}`,
                                                            e.target.value
                                                          )
                                                        }
                                                        className={
                                                          classes.input
                                                        }
                                                      />
                                                    )}
                                                </React.Fragment>
                                              )
                                            )}
                                          </div>
                                        )}
                                        {question.question?.startsWith(
                                          "If the information about Governance structure and composition of the organization is publicly available (web pages or annual reports), then provide the link in the GRI content index instead of repeating it."
                                        ) && (
                                          <Box
                                            width="100%"
                                            display="flex"
                                            justifyContent="center"
                                          >
                                            <Typography
                                              fontSize={16}
                                              fontWeight={600}
                                              sx={{
                                                paddingTop: 15,
                                                paddingBottom: -6,
                                                color: "#000",
                                                lineHeight: 1,
                                              }}
                                            >
                                              OR
                                            </Typography>
                                          </Box>
                                        )}

                                        {question.condition ===
                                          "question_split" &&
                                          question.options?.length > 0 && (
                                            <ul
                                              style={{
                                                marginTop: "8px",
                                                paddingLeft: "24px",
                                                color: "#555",
                                              }}
                                            >
                                              {question.options.map(
                                                (opt, idx) => (
                                                  <li
                                                    key={idx}
                                                    style={{
                                                      fontSize: "16px",
                                                      marginBottom: "4px",
                                                      lineHeight: "1.5",
                                                      color: "#000",
                                                    }}
                                                  >
                                                    {opt}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          )}

                                        {question.question_type ===
                                          "multiselect_check_box" && (
                                          <div
                                            style={{
                                              display: "grid",

                                              gridTemplateColumns: `repeat(${
                                                question.options.some(
                                                  (option) =>
                                                    option.split(" ").length > 6
                                                )
                                                  ? 2
                                                  : 4
                                              }, 1fr)`,
                                              gap: "16px",
                                              alignItems: "left",
                                              position: "relative",
                                              textAlign: "left",
                                            }}
                                          >
                                            {question.options.map(
                                              (option, idx) => (
                                                <React.Fragment key={idx}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        className={
                                                          classes.selectCheckbox
                                                        }
                                                        checked={
                                                          selectedValues[
                                                            question.id
                                                          ]?.includes(option) ||
                                                          false
                                                        }
                                                        onChange={(e) =>
                                                          handleCheckboxChange(
                                                            e,
                                                            question.id
                                                          )
                                                        }
                                                        value={option}
                                                        sx={{
                                                          color:
                                                            "#5A404E !important",
                                                          "&.Mui-checked": {
                                                            color:
                                                              "#8C2148 !important",
                                                          },
                                                          marginRight: "8px",
                                                        }}
                                                      />
                                                    }
                                                    label={option}
                                                    sx={{
                                                      margin: "0 !important",
                                                      width: "fit-content",
                                                    }}
                                                  />

                                                  {selectedValues[
                                                    question.id
                                                  ] &&
                                                    /other/i.test(
                                                      selectedValues[
                                                        question.id
                                                      ]
                                                    ) &&
                                                    /other/i.test(option) && (
                                                      <div
                                                        style={{
                                                          gridColumn: "1 / -1",
                                                          width: "100%",
                                                          marginTop: "16px",
                                                        }}
                                                      >
                                                        <TextField
                                                          variant="outlined"
                                                          placeholder="Please type your Answer"
                                                          multiline
                                                          rows={3}
                                                          value={
                                                            textAnswers[
                                                              `other-${question.id}`
                                                            ] || ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTextInputChange(
                                                              `other-${question.id}`,
                                                              e.target.value
                                                            )
                                                          }
                                                          sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root":
                                                              {
                                                                borderRadius:
                                                                  "8px",
                                                                borderColor:
                                                                  "#5A404E",
                                                              },
                                                          }}
                                                        />
                                                      </div>
                                                    )}
                                                </React.Fragment>
                                              )
                                            )}
                                          </div>
                                        )}
                                        {(question.question_type === "text" ||
                                          question.question_type ===
                                            "Text Field") && (
                                          <>
                                            <Box minHeight={80} width={"100%"}>
                                              {question.question
                                                ?.toLowerCase()
                                                .includes(
                                                  "corporate address"
                                                ) ? (
                                                (() => {
                                                  const children =
                                                    subQuestionDict[
                                                      question.id
                                                    ] || [];

                                                  const streetId =
                                                    children[0]?.id;
                                                  const unitId =
                                                    children[1]?.id;
                                                  const countryId =
                                                    children[2]?.id;
                                                  const stateId =
                                                    children[3]?.id;
                                                  const postalId =
                                                    children[4]?.id;

                                                  return (
                                                    <Grid container spacing={2}>
                                                      <Grid item xs={6}>
                                                        <CeroInput
                                                          label="Street Address"
                                                          placeholder="e.g., 123 Main Street"
                                                          fullWidth
                                                          multiline
                                                          rows={2}
                                                          value={
                                                            textAnswers[
                                                              streetId
                                                            ] || ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTextInputChange(
                                                              streetId,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </Grid>
                                                      <Grid item xs={6}>
                                                        <CeroInput
                                                          label="Unit Number"
                                                          placeholder="Enter Unit Number (if applicable)"
                                                          fullWidth
                                                          multiline
                                                          rows={2}
                                                          value={
                                                            textAnswers[
                                                              unitId
                                                            ] || ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTextInputChange(
                                                              unitId,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </Grid>
                                                      <Grid item xs={6}>
                                                        <CeroAutoComplete
                                                          label="Country"
                                                          options={countryList}
                                                          value={
                                                            country ||
                                                            countryList.find(
                                                              (c) =>
                                                                c.value ===
                                                                  textAnswers[
                                                                    countryId
                                                                  ] ||
                                                                c.label ===
                                                                  textAnswers[
                                                                    countryId
                                                                  ]
                                                            )
                                                          }
                                                          onChange={(
                                                            e,
                                                            value
                                                          ) => {
                                                            setCountry(value);
                                                            setState("");
                                                            handleTextInputChange(
                                                              countryId,
                                                              value?.value || ""
                                                            );
                                                          }}
                                                          isOptionEqualToValue={(
                                                            option,
                                                            value
                                                          ) =>
                                                            option.label ===
                                                              value?.label ||
                                                            option.value ===
                                                              value?.value
                                                          }
                                                          fullWidth
                                                        />
                                                      </Grid>
                                                      <Grid item xs={6}>
                                                        <CeroAutoComplete
                                                          label="State / Province / Region"
                                                          options={Object.keys(
                                                            stateNames
                                                          ).map((s) => ({
                                                            label: s,
                                                            value: s,
                                                          }))}
                                                          value={
                                                            state?.value
                                                              ? {
                                                                  label:
                                                                    state.label,
                                                                  value:
                                                                    state.value,
                                                                }
                                                              : Object.keys(
                                                                  stateNames
                                                                )
                                                                  .map((s) => ({
                                                                    label: s,
                                                                    value: s,
                                                                  }))
                                                                  .find(
                                                                    (opt) =>
                                                                      opt.value ===
                                                                      textAnswers[
                                                                        stateId
                                                                      ]
                                                                  ) || null
                                                          }
                                                          onChange={(
                                                            e,
                                                            value
                                                          ) => {
                                                            setState(value);
                                                            handleTextInputChange(
                                                              stateId,
                                                              value?.value || ""
                                                            );
                                                          }}
                                                          isOptionEqualToValue={(
                                                            option,
                                                            value
                                                          ) =>
                                                            option.value ===
                                                            value?.value
                                                          }
                                                          fullWidth
                                                        />
                                                      </Grid>
                                                      <Grid item xs={6}>
                                                        <CeroInput
                                                          label="Postal Code / ZIP"
                                                          placeholder="Enter Postal Code / ZIP"
                                                          fullWidth
                                                          multiline
                                                          rows={2}
                                                          value={
                                                            textAnswers[
                                                              question.id
                                                            ] || ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTextInputChange(
                                                              postalId,
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </Grid>
                                                    </Grid>
                                                  );
                                                })()
                                              ) : (
                                                <CeroInput
                                                  className={
                                                    classes.textAreaContainer
                                                  }
                                                  rows={3}
                                                  placeholder="Please type your Answer"
                                                  id={`answer-${question.id}`}
                                                  name={`answer-${question.id}`}
                                                  label="Please type your Answer"
                                                  multiline
                                                  value={
                                                    textAnswers[question.id] ||
                                                    ""
                                                  }
                                                  onChange={(e) =>
                                                    handleTextInputChange(
                                                      question.id,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              )}
                                            </Box>

                                            {/* Show OR below input only for specific question */}
                                            {question.question?.startsWith(
                                              "If the information about Governance structure and composition of the organization is publicly available (web pages or annual reports), then provide the link in the GRI content index instead of repeating it."
                                            ) && (
                                              <Box
                                                width="100%"
                                                display="flex"
                                                justifyContent="center"
                                              >
                                                <Typography
                                                  fontSize={16}
                                                  fontWeight={600}
                                                  sx={{
                                                    paddingTop: 15,
                                                    paddingBottom: -6,
                                                    color: "#000",
                                                    lineHeight: 1,
                                                  }}
                                                >
                                                  OR
                                                </Typography>
                                              </Box>
                                            )}
                                          </>
                                        )}
                                        {question.question_type ===
                                          "short_text" &&
                                          (() => {
                                            if (
                                              section ===
                                                "SECTION A: GENERAL DISCLOSURES" &&
                                              subSection ===
                                                "Details of the listed entity"
                                            ) {
                                              return (
                                                <Box
                                                  sx={{
                                                    width: "48%",
                                                    paddingRight: "16px",
                                                    marginBottom: "24px",
                                                  }}
                                                >
                                                  <Typography
                                                    fontSize={18}
                                                    fontWeight={500}
                                                    variant="h3"
                                                    paddingBottom={1}
                                                  >
                                                    {displayIndex}.{" "}
                                                    {question.question}
                                                  </Typography>
                                                  <CeroInput
                                                    classes={{
                                                      container:
                                                        classes.textAreaContainerShort,
                                                      input:
                                                        classes.textAreaContainerInput,
                                                    }}
                                                    rows={3}
                                                    placeholder="Please type your Answer"
                                                    id={`answer-${question.id}`}
                                                    name={`answer-${question.id}`}
                                                    label="Please type your Answer"
                                                    multiline
                                                    fullWidth
                                                    value={
                                                      textAnswers[
                                                        question.id
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleTextInputChange(
                                                        question.id,
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </Box>
                                              );
                                            } else if (
                                              question.question ===
                                              "Contact Number"
                                            ) {
                                              return (
                                                <CeroPhoneInput
                                                  required
                                                  fullWidth
                                                  label="Contact Number"
                                                  name="contact number"
                                                  value={
                                                    textAnswers[question.id] ||
                                                    ""
                                                  }
                                                  onChange={(value) =>
                                                    handleTextInputChange(
                                                      question.id,
                                                      value
                                                    )
                                                  }
                                                  classes={{
                                                    container:
                                                      classes.phoneInput,
                                                  }}
                                                />
                                              );
                                            } else if (
                                              question.question ===
                                              "Corporate address"
                                            ) {
                                              const children =
                                                subQuestionDict[question.id] ||
                                                [];
                                              const streetId = question.id;
                                              const unitId = children.find(
                                                (c) =>
                                                  c.question
                                                    .toLowerCase()
                                                    .includes("unit")
                                              )?.id;
                                              const countryId = children.find(
                                                (c) =>
                                                  c.question
                                                    .toLowerCase()
                                                    .includes("country")
                                              )?.id;

                                              const stateId = children.find(
                                                (c) =>
                                                  c.question
                                                    .toLowerCase()
                                                    .includes("state")
                                              )?.id;
                                              const postalId = children.find(
                                                (c) =>
                                                  c.question
                                                    .toLowerCase()
                                                    .includes("postal")
                                              )?.id;

                                              return (
                                                <Grid container spacing={2}>
                                                  <Grid item xs={6}>
                                                    <CeroInput
                                                      label="Street Address"
                                                      placeholder="e.g., 123 Main Street"
                                                      fullWidth
                                                      multiline
                                                      rows={2}
                                                      value={
                                                        textAnswers[streetId] ||
                                                        ""
                                                      }
                                                      onChange={(e) =>
                                                        handleTextInputChange(
                                                          streetId,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <CeroInput
                                                      label="Unit Number"
                                                      placeholder="Enter Unit Number (if applicable)"
                                                      fullWidth
                                                      multiline
                                                      rows={2}
                                                      value={
                                                        textAnswers[unitId] ||
                                                        ""
                                                      }
                                                      onChange={(e) =>
                                                        handleTextInputChange(
                                                          unitId,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <CeroAutoComplete
                                                      label="Country"
                                                      options={countryList}
                                                      value={
                                                        country ||
                                                        countryList.find(
                                                          (c) =>
                                                            c.id ===
                                                            textAnswers[
                                                              countryId
                                                            ]
                                                        ) ||
                                                        null
                                                      }
                                                      onChange={(e, value) => {
                                                        setCountry(value);
                                                        setState("");
                                                        handleTextInputChange(
                                                          countryId,
                                                          value?.id || ""
                                                        );
                                                      }}
                                                      isOptionEqualToValue={(
                                                        option,
                                                        value
                                                      ) =>
                                                        option.id === value?.id
                                                      }
                                                      fullWidth
                                                      sx={{
                                                        "& .MuiOutlinedInput-root":
                                                          {
                                                            height: "48px",
                                                            padding: "0 14px",
                                                          },
                                                      }}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <CeroAutoComplete
                                                      label="State / Province / Region"
                                                      options={Object.keys(
                                                        stateNames
                                                      ).map((s) => ({
                                                        label: s,
                                                        value: s,
                                                      }))}
                                                      value={
                                                        state?.value
                                                          ? {
                                                              label:
                                                                state.label,
                                                              value:
                                                                state.value,
                                                            }
                                                          : Object.keys(
                                                              stateNames
                                                            )
                                                              .map((s) => ({
                                                                label: s,
                                                                value: s,
                                                              }))
                                                              .find(
                                                                (opt) =>
                                                                  opt.value ===
                                                                  textAnswers[
                                                                    stateId
                                                                  ]
                                                              ) || null
                                                      }
                                                      onChange={(e, value) => {
                                                        setState(value);
                                                        handleTextInputChange(
                                                          stateId,
                                                          value?.value || ""
                                                        );
                                                      }}
                                                      isOptionEqualToValue={(
                                                        option,
                                                        value
                                                      ) =>
                                                        option.label ===
                                                          value?.label ||
                                                        option.value ===
                                                          value?.value
                                                      }
                                                      fullWidth
                                                      sx={{
                                                        "& .MuiOutlinedInput-root":
                                                          {
                                                            height: "48px",
                                                            padding: "0 14px",
                                                          },
                                                      }}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <CeroInput
                                                      label="Postal Code / ZIP"
                                                      placeholder="Enter Postal Code / ZIP"
                                                      fullWidth
                                                      multiline
                                                      rows={2}
                                                      value={
                                                        textAnswers[postalId] ||
                                                        ""
                                                      }
                                                      onChange={(e) =>
                                                        handleTextInputChange(
                                                          postalId,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </Grid>
                                                </Grid>
                                              );
                                            } else {
                                              return (
                                                <Box
                                                  width={"50%"}
                                                  paddingRight={2}
                                                  marginBottom={3}
                                                >
                                                  <CeroInput
                                                    classes={{
                                                      container:
                                                        classes.textAreaContainerShort,
                                                      input:
                                                        classes.textAreaContainerInput,
                                                    }}
                                                    rows={3}
                                                    placeholder="Please type your Answer"
                                                    id={`answer-${question.id}`}
                                                    name={`answer-${question.id}`}
                                                    label="Please type your Answer"
                                                    multiline
                                                    value={
                                                      textAnswers[
                                                        question.id
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleTextInputChange(
                                                        question.id,
                                                        e.target.value
                                                      )
                                                    }
                                                    error={
                                                      isEmail &&
                                                      !isValidEmail(
                                                        textAnswers[question.id]
                                                      )
                                                        ? "Email is not valid"
                                                        : ""
                                                    }
                                                  />
                                                </Box>
                                              );
                                            }
                                          })()}

                                        {question.question_type === "table" && (
                                          <Grid width={"100%"}>
                                            {question.instructions?.map(
                                              (inst, i) => (
                                                <Typography
                                                  paddingLeft={6}
                                                  paddingY={1}
                                                  key={i}
                                                >
                                                  {i + 1}. {inst}
                                                </Typography>
                                              )
                                            )}
                                            {question.condition ===
                                            "brsr_table_1" ? (
                                              <TotalEmployeesTable
                                                employeeTable={employeeTable}
                                                setEmployeeTable={
                                                  setEmployeeTable
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_2" ? (
                                              <TotalEmployeesTable2
                                                employeeTable2={employeeTable2}
                                                setEmployeeTable2={
                                                  setEmployeeTable2
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_3" ? (
                                              <ShareholdingTable
                                                shareholdingTable={
                                                  shareholdingTable
                                                }
                                                setShareholdingTable={
                                                  setShareholdingTable
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_4" ? (
                                              <GrievanceMechanismTable
                                                grievanceTable={grievanceTable}
                                                setGrievanceTable={
                                                  setGrievanceTable
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_5" ? (
                                              <MaterialIssuesTable
                                                materialTable={materialTable}
                                                setMaterialTable={
                                                  setMaterialTable
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_6" ? (
                                              <DisclosureTable
                                                disclosureData={disclosureData}
                                                setDisclosureData={
                                                  setDisclosureData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_7" ? (
                                              <BoardReviewTable
                                                reviewData={reviewData}
                                                setReviewData={setReviewData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_8" ? (
                                              <ReviewFrequencyTable
                                                frequencyData={frequencyData}
                                                setFrequencyData={
                                                  setFrequencyData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_9" ? (
                                              <PolicyGapReasonTable
                                                reasonData={reasonData}
                                                setReasonData={setReasonData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_10" ? (
                                              <TrainingAwarenessTable
                                                trainingData={trainingData}
                                                setTrainingData={
                                                  setTrainingData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_11" ? (
                                              <LegalActionsTable
                                                legalData={legalData}
                                                setLegalData={setLegalData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_12" ? (
                                              <CaseStudiesTable
                                                caseStudies={caseStudies}
                                                setCaseStudies={setCaseStudies}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_13" ? (
                                              <EmployeeCountComparisonTable
                                                data={data}
                                                setData={setData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_14" ? (
                                              <ConflictOfInterestTable
                                                conflictData={conflictData}
                                                setConflictData={
                                                  setConflictData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_15" ? (
                                              <AccountsPayableTable
                                                payableData={payableData}
                                                setPayableData={setPayableData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_16" ? (
                                              <ConcentrationMetricsTable
                                                concentrationtableData={
                                                  concentrationtableData
                                                }
                                                setConcentrationTableData={
                                                  setConcentrationTableData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_17" ? (
                                              <AwarenessProgramTable
                                                awarenessData={awarenessData}
                                                setAwarenessData={
                                                  setAwarenessData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_18" ? (
                                              <ImprovementImpactTable
                                                improvementData={
                                                  improvementData
                                                }
                                                setImprovementData={
                                                  setImprovementData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_19" ? (
                                              <ImprovementImpactTable1
                                                improvementData1={
                                                  improvementData1
                                                }
                                                setImprovementData1={
                                                  setImprovementData1
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_20" ? (
                                              <ProductRiskTable
                                                productrows={productrows}
                                                setProductRows={setProductRows}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_21" ? (
                                              <RecycledMaterialTable
                                                recycledData={recycledData}
                                                setRecycledData={
                                                  setRecycledData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_22" ? (
                                              <WasteManagementTable
                                                wastedata={wastedata}
                                                setWasteData={setWasteData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_23" ? (
                                              <ReclaimedPackagingTable
                                                packagedata={packagedata}
                                                setPackageData={setPackageData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_24" ? (
                                              <>
                                                <EmployeeBenefitCoverageTable
                                                  benefitTable={benifitTable}
                                                  setBenefitTable={
                                                    setBenifitTable
                                                  }
                                                />
                                                {subQuestionDict[
                                                  question.id
                                                ]?.find(
                                                  (child) =>
                                                    child.condition ===
                                                    "brsr_table_25"
                                                ) && (
                                                  <WorkersBenefitCoverageTable
                                                    workersbenefitTable={
                                                      workersbenefitTable
                                                    }
                                                    setWorkersBenefitTable={
                                                      setWorkersBenefitTable
                                                    }
                                                  />
                                                )}
                                              </>
                                            ) : question.condition ===
                                              "brsr_table_26" ? (
                                              <WellBeingCostTable
                                                wellbeingdata={wellbeingdata}
                                                setWellbeingData={
                                                  setWellbeingData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_27" ? (
                                              <StatutoryBenefitsTable
                                                statutorydata={statutorydata}
                                                setStatutoryData={
                                                  setStatutoryData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_28" ? (
                                              <ReturnToWorkRateTable
                                                returndata={returndata}
                                                setReturnData={setReturnData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_29" ? (
                                              <ReclaimedProductTable
                                                reclaimedproductdata={
                                                  reclaimedproductdata
                                                }
                                                setReclaimedProductData={
                                                  setReclaimedProductData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_30" ? (
                                              <UnionAssociationTable
                                                uniondata={uniondata}
                                                setUnionData={setUnionData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_31" ? (
                                              <TrainingMeasuresTable
                                                trainingmeasuresdata={
                                                  trainingmeasuresdata
                                                }
                                                setTrainingMeasuresData={
                                                  setTrainingMeasuresData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_32" ? (
                                              <WorkforceFYTable
                                                fydata={fydata}
                                                setFyData={setFyData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_33" ? (
                                              <SafetyIncidentTable
                                                safetyData={safetyData}
                                                setSafetyData={setSafetyData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_34" ? (
                                              <PfGratuityDisputeTable
                                                pfdata={pfdata}
                                                setPfData={setPfData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_35" ? (
                                              <AssessmentTable
                                                assessmentData={assessmentData}
                                                setAssessmentData={
                                                  setAssessmentData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_36" ? (
                                              <RehabilitationEmploymentTable
                                                rehabdata={rehabdata}
                                                setRehabData={setRehabData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_37" ? (
                                              <ValueChainAssessmentTable
                                                valuedata={valuedata}
                                                setValueData={setValueData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_38" ? (
                                              <StakeholderEngagementTable
                                                stakeholderdata={
                                                  stakeholderdata
                                                }
                                                setStakeholderData={
                                                  setStakeholderData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_39" ? (
                                              <CoverageComparisonTable
                                                coveragedata={coveragedata}
                                                setCoverageData={
                                                  setCoverageData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_40" ? (
                                              <WageDistributionTable
                                                wageData={wageData}
                                                setWageData={setWageData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_41" ? (
                                              <RemunerationTable
                                                remunerationdata={
                                                  remunerationdata
                                                }
                                                setRemunerationData={
                                                  setRemunerationData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_42" ? (
                                              <FemaleWagePercentageTable
                                                femaleWageData={femaleWageData}
                                                setFemaleWageData={
                                                  setFemaleWageData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_43" ? (
                                              <HumanRightsComplaintsTable
                                                humanrightsdata={
                                                  humanrightsdata
                                                }
                                                setHumanrightsData={
                                                  setHumanrightsData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_44" ? (
                                              <PoshComplaintsTable
                                                poshData={poshData}
                                                setPoshData={setPoshData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_45" ? (
                                              <PlantAssessmentTable
                                                plantAssessmentData={
                                                  plantAssessmentData
                                                }
                                                setPlantAssessmentData={
                                                  setPlantAssessmentData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_46" ? (
                                              <PartnerEthicsAssessmentTable
                                                valueChainAssessmentData={
                                                  valueChainAssessmentData
                                                }
                                                setValueChainAssessmentData={
                                                  setValueChainAssessmentData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_47" ? (
                                              <EnergyConsumptionTable
                                                energyData={energyData}
                                                setEnergyData={setEnergyData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_48" ? (
                                              <WaterWithdrawalAndConsumptionTable
                                                waterData={waterData}
                                                setWaterData={setWaterData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_49" ? (
                                              <WaterDischargeTreatmentTable
                                                dischargeData={dischargeData}
                                                setDischargeData={
                                                  setDischargeData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_50" ? (
                                              <AirPollutantEmissionTable
                                                airdata={airdata}
                                                setAirData={setAirData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_51" ? (
                                              <Scope1And2GHGEmissionTable
                                                scopeData={scopeData}
                                                setScopeData={setScopeData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_52" ? (
                                              <WasteManagementEntityTable
                                                wasteManagementData={
                                                  wasteManagementData
                                                }
                                                setWasteManagementData={
                                                  setWasteManagementData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_53" ? (
                                              <EnvironmentalClearanceTable
                                                envclearanceData={
                                                  envclearanceData
                                                }
                                                setEnvClearanceData={
                                                  setEnvClearanceData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_54" ? (
                                              <EIAComplianceTable
                                                eiaData={eiaData}
                                                setEiaData={setEiaData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_55" ? (
                                              <RegulatoryNonComplianceTable
                                                nonComplianceData={
                                                  nonComplianceData
                                                }
                                                setNonComplianceData={
                                                  setNonComplianceData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_56" ? (
                                              <WaterUsageAndDischargeTable
                                                waterusagedata={waterusagedata}
                                                setWaterUsageData={
                                                  setWaterUsageData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_57" ? (
                                              <Scope3EmissionsTable
                                                scope3Data={scope3Data}
                                                setScope3Data={setScope3Data}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_58" ? (
                                              <InitiativeOutcomeTable
                                                initiativeData={initiativeData}
                                                setInitiativeData={
                                                  setInitiativeData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_59" ? (
                                              <TradeAssociationsTable
                                                associations={associations}
                                                setAssociations={
                                                  setAssociations
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_60" ? (
                                              <LegalAuthoritiesTable
                                                authorityData={authorityData}
                                                setAuthorityData={
                                                  setAuthorityData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_61" ? (
                                              <PublicPolicyAdvocacyTable
                                                advocacyData={advocacyData}
                                                setAdvocacyData={
                                                  setAdvocacyData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_62" ? (
                                              <SIATable
                                                siaData={siaData}
                                                setSiaData={setSiaData}
                                              />
                                            ) : question.condition ===
                                              "brsr_table_63" ? (
                                              <RehabilitationResettlementTable
                                                resettlementData={
                                                  resettlementData
                                                }
                                                setResettlementData={
                                                  setResettlementData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_64" ? (
                                              <SourcingBreakdownTable
                                                sourcingData={sourcingData}
                                                setSourcingData={
                                                  setSourcingData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_65" ? (
                                              <LocationDistributionTable
                                                locationData={locationData}
                                                setLocationData={
                                                  setLocationData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_66" ? (
                                              <SocialImpactActionTable
                                                socialImpactData={
                                                  socialImpactData
                                                }
                                                setSocialImpactData={
                                                  setSocialImpactData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_67" ? (
                                              <AspirationalDistrictTable
                                                aspirationalDistrictData={
                                                  aspirationalDistrictData
                                                }
                                                setAspirationalDistrictData={
                                                  setAspirationalDistrictData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_68" ? (
                                              <TraditionalKnowledgeTable
                                                traditionalKnowledgeData={
                                                  traditionalKnowledgeData
                                                }
                                                setTraditionalKnowledgeData={
                                                  setTraditionalKnowledgeData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_69" ? (
                                              <RegulatoryCaseTable
                                                regulatoryCaseData={
                                                  regulatoryCaseData
                                                }
                                                setRegulatoryCaseData={
                                                  setRegulatoryCaseData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_70" ? (
                                              <CSRBeneficiariesTable
                                                csrBeneficiaryData={
                                                  csrBeneficiaryData
                                                }
                                                setCsrBeneficiaryData={
                                                  setCsrBeneficiaryData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_71" ? (
                                              <TurnoverParameterTable
                                                turnoverData={turnoverData}
                                                setTurnoverData={
                                                  setTurnoverData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_72" ? (
                                              <CustomerComplaintsTable
                                                complaintData={complaintData}
                                                setComplaintData={
                                                  setComplaintData
                                                }
                                              />
                                            ) : question.condition ===
                                              "brsr_table_73" ? (
                                              <ProductRecallTable
                                                recallData={recallData}
                                                setRecallData={setRecallData}
                                              />
                                            ) : (
                                              <></>
                                            )}
                                          </Grid>
                                        )}
                                        {question.question_type === "date" && (
                                          <CeroDate
                                            label="Date"
                                            value={
                                              dateAnswers[question.id] || ""
                                            }
                                            onChange={(date) =>
                                              handleDateInputChange(
                                                question.id,
                                                date
                                              )
                                            }
                                            year={2025}
                                          />
                                        )}
                                      </Box>
                                    </Grid>
                                  );
                                })}
                              </div>
                            );
                          });
                        })()}
                      </div>
                    );
                  }
                )}
              </React.Fragment>
            ))}
          </div>
        </Grid>
      )}
    </div>
  );
}

export default BrsrQuestionnaire;
